import React from "react";
import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { BookOpen, MessageCircle, FileQuestion, Mail, LifeBuoy } from "lucide-react";

export default function HelpCenter() {
  const cards = [
    { icon: FileQuestion, title: "FAQ", to: "/faq", body: "Quick answers to common questions about payments, payouts, and policies." },
    { icon: BookOpen, title: "Role guides", to: "/guides", body: "Step-by-step playbooks for suppliers, merchants, affiliates, creators, and more." },
    { icon: MessageCircle, title: "Contact us", to: "/contact", body: "Reach our support team. Average reply: 4 business hours." },
  ];
  return (
    <PublicLayout>
      <section className="border-b border-border bg-card">
        <div className="max-w-5xl mx-auto px-6 py-16">
          <LifeBuoy size={32} className="text-secondary" />
          <h1 className="mt-6 font-display text-4xl md:text-5xl font-black tracking-tighter text-primary leading-none">Help Center</h1>
          <p className="mt-4 text-muted-foreground max-w-xl">Everything you need to run your Vendora business. If you can't find an answer, we're an email away.</p>
        </div>
      </section>
      <section className="max-w-5xl mx-auto px-6 py-10 grid md:grid-cols-3 gap-3">
        {cards.map((c) => (
          <Link key={c.to} to={c.to} className="v-card flex flex-col" data-testid={`help-${c.title.toLowerCase().replace(/\s/g, "-")}`}>
            <c.icon size={28} strokeWidth={1.5} className="text-secondary" />
            <h2 className="mt-6 font-display text-xl font-semibold text-primary">{c.title}</h2>
            <p className="mt-2 text-sm text-muted-foreground flex-1">{c.body}</p>
          </Link>
        ))}
      </section>
    </PublicLayout>
  );
}
